function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconExport = function SvgIconExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 12v7H5v-7H3v7a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2v-7Zm-6 .7 2.6-2.6 1.4 1.4-5 5-5-5 1.4-1.4 2.6 2.6V3h2Z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgIconExport;